export const ALL_PRODUCT_REQUEST='ALL_PRODUCT_REQUEST';
export const ALL_PRODUCT_SUCCESS='ALL_PRODUCT_SUCCESS';
export const ALL_PRODUCT_FAIL='ALL_PRODUCT_FAIL';

export const NEW_PRODUCT_REQUEST='NEW_PRODUCT_REQUEST';
export const NEW_PRODUCT_SUCCESS='NEW_PRODUCT_SUCCESS';
export const NEW_PRODUCT_FAIL='NEW_PRODUCT_FAIL';
export const NEW_PRODUCT_RESET='NEW_PRODUCT_RESET';



export const ADMIN_PRODUCT_REQUEST='ADMIN_PRODUCT_REQUEST';
export const ADMIN_PRODUCT_SUCCESS='ADMIN_PRODUCT_SUCCESS';
export const ADMIN_PRODUCT_FAIL='ADMIN_PRODUCT_FAIL';

export const ADMIN_PRODUCT_DELETE_REQUEST='ADMIN_PRODUCT_DELETE_REQUEST';
export const ADMIN_PRODUCT_DELETE_SUCCESS='ADMIN_PRODUCT_DELETE_SUCCESS';
export const ADMIN_PRODUCT_DELETE_FAIL='ADMIN_PRODUCT_DELETE_FAIL';


export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_RESET = "UPDATE_PRODUCT_RESET";
export const UPDATE_PRODUCT_FAIL = "UPDATE_PRODUCT_FAIL";


export const ADMIN_PRODUCT_RESET='ADMIN_PRODUCT_RESET';

export const CLEAR_ERRORS='CLEAR_ERRORS'
